import { defineEffect } from '../../../core/effect';
import { spec } from '../fx/new_phase';

/** 状況 `new_phase_battle`（組み立ては `../fx/new_phase.js`。arcade はどの状況も同じ絵） */
export default defineEffect({ situation: 'new_phase_battle', role: 'effect', ...spec }, 'new_phase_battle_effect.js');
